// =============================================================================
// CREATE GAME PAGE - Choose between donation or petition campaign
// =============================================================================

import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';

interface CreateGamePageProps {
  onBack: () => void;
}

export function CreateGamePage({ onBack }: Readonly<CreateGamePageProps>) {
  const handleDonation = () => {
    window.location.href = '/share-donation';
  };

  const handlePetition = () => {
    window.location.href = '/share-petition';
  };

  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center px-4 py-8 relative"
      role="main"
      aria-label="Створення власної гри"
    >
      <motion.div
        className="relative z-10 w-full max-w-lg"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15, delayChildren: 0.1 },
          },
        }}
      >
        {/* Header */}
        <motion.div variants={fadeInUp} className="text-center mb-10">
          <button
            onClick={onBack}
            className="text-war-dim hover:text-war-primary text-xs mb-6 flex items-center gap-2 transition-colors mx-auto"
            aria-label="Повернутися назад"
          >
            <span>←</span>
            <span className="tracking-wider uppercase">Назад</span>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-war-bright tracking-wider uppercase mb-3">
            Створення власної гри
          </h1>
          <p className="text-war-dim text-sm">
            Оберіть тип кампанії для інтеграції
          </p>
        </motion.div>

        {/* Options */}
        <motion.div variants={fadeInUp} className="space-y-4">
          {/* Donation Option */}
          <button
            onClick={handleDonation}
            className="w-full group glass-card p-6 text-left transition-all hover:border-war-primary/50 active:scale-[0.99]"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="text-war-primary text-lg font-bold tracking-widest uppercase">
                Збір коштів
              </div>
              <span className="text-war-dim/50 group-hover:text-war-primary transition-colors text-xl">
                →
              </span>
            </div>
            <p className="text-war-dim text-xs leading-relaxed">
              Додайте посилання на збір коштів для ЗСУ або гуманітарної
              допомоги. Генерується одразу. Формує посилання на гру з інтегрованим збором.
            </p>
            <div className="mt-4 pt-3 border-t border-war-dim/10">
              <div className="text-[10px] text-war-dim/60 font-mono uppercase tracking-widest">
                Працює з monobank
              </div>
            </div>
          </button>

          {/* Petition Option */}
          <button
            onClick={handlePetition}
            className="w-full group glass-card p-6 text-left transition-all hover:border-war-amber/50 active:scale-[0.99]"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="text-war-amber text-lg font-bold tracking-widest uppercase">
                Петиція
              </div>
              <span className="text-war-dim/50 group-hover:text-war-amber transition-colors text-xl">
                →
              </span>
            </div>
            <p className="text-war-dim text-xs leading-relaxed">
              Додайте посилання на петицію для привернення уваги до важливих
              питань. Генерується одразу. Формує посилання на гру з інтегрованою петицією.
            </p>
            <div className="mt-4 pt-3 border-t border-war-dim/10">
              <div className="text-[10px] text-war-dim/60 font-mono uppercase tracking-widest">
                Працює з petition.president.gov.ua
              </div>
            </div>
          </button>
        </motion.div>

        {/* Info Note */}
        <motion.div
          variants={fadeInUp}
          className="mt-8 text-center text-[10px] text-war-dim/40 font-mono tracking-wide"
        >
          <p>Гравцю буде запропоновано підтримати петицію чи збір в процесі гри</p>
        </motion.div>

        {/* Footer */}
        <motion.div
          variants={fadeInUp}
          className="mt-10 text-center text-[9px] text-war-dim/30 font-mono tracking-widest uppercase"
        >

        </motion.div>
      </motion.div>
    </main>
  );
}
